import { combineReducers } from 'redux';
import user from './login';
import sessions from './sessions.js';
import proposals from './proposals.js';
import breadcrumbsList from './breadcrumbs.js';
import configuration from './configuration.js';
import application from './application.js';
import jobs from './jobs.js';

export default combineReducers({
    user,
    breadcrumbsList,
    sessions,
    configuration,
    application,
    proposals,
    jobs
});


// WEBPACK FOOTER //
// ./src/reducers/index.js